module.exports = __webpack_public_path__ + "static/media/pretreat_line.7e8a2f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/room/rooms/devices/pretreat_line.png
// module id = 357
// module chunks = 0